(() => {
  window.eveBundlePreselect = (container, maxItems, update) => {
    const params = new URLSearchParams(location.search);
    if (params.has('bundleId') || container.dataset.quizPreselected === 'true') return;
    const keys = ['quiz_variants', 'quiz_products', 'quiz_handles'];
    if (!keys.some(key => params.has(key))) return;
    container.dataset.quizPreselected = 'true';
    const read = (key, pattern) => (params.get(key) || '').split(',').slice(0, 50).map(value => pattern.test(value) ? value : '');
    const variants = read(keys[0], /^\d{1,30}$/);
    const products = read(keys[1], /^\d{1,30}$/);
    const handles = read(keys[2], /^[a-zA-Z0-9_-]{1,200}$/);
    const candidates = [
      ...container.querySelectorAll('.bundle-product-card'),
      ...document.querySelectorAll('.product-upsell__toggle'),
    ];
    const used = new Set();
    let total = 0;
    let skipped = 0;
    for (let i = 0; i < Math.max(variants.length, products.length, handles.length); i++) {
      if (!variants[i] && !products[i] && !handles[i]) continue;
      const card = candidates.find(el => variants[i] && el.dataset.variantId === variants[i])
        || candidates.find(el => products[i] && el.dataset.productId === products[i])
        || candidates.find(el => handles[i] && el.dataset.productHandle === handles[i]);
      if (!card) { skipped++; continue; }
      if (used.has(card.dataset.variantId)) continue;
      if (card.dataset.available !== 'true' || card.disabled) { skipped++; continue; }
      const addon = card.matches('.product-upsell__toggle') || card.dataset.isAddon === 'true';
      if (!addon && total >= maxItems) { skipped++; continue; }
      if (card.matches('.product-upsell__toggle')) {
        card.checked = true;
      } else {
        const input = card.querySelector('.quantity-input-bundle');
        if (!input) { skipped++; continue; }
        input.value = '1';
        card.querySelector('.add-bundle-item-btn')?.classList.add('hidden');
        card.querySelector('.quantity-selector')?.classList.remove('hidden');
      }
      used.add(card.dataset.variantId);
      if (!addon) total++;
    }
    update();
    if (skipped) {
      const notice = document.createElement('p');
      notice.setAttribute('role', 'status');
      notice.className = 'bundle-quiz-preselect-notice';
      notice.textContent = container.dataset.quizUnavailableMessage;
      container.prepend(notice);
    }
  };
})();
